<template>

    <div class="max-width-md-large m-auto">
        <div class="card card--regular card--green text-center mb-3">
            <div class="c-charcoal fs-32 sm-fs-20 lh-15 fw-light">You're making a <span class="fw-bold lowercase">{{ type }}</span> of <span class="fw-bold">£{{ amount }}</span></div>
        </div>

        <form @onSubmit.prevent="submit">


            <div v-if="block.custom_fields" class="card card--large card--green mb-3">
                <h3 v-if="block.custom_fields.title" class="text-center">{{ block.custom_fields.title }}</h3>
                <div v-for="(field, index) in block.custom_fields.fields" class="mt-3 sm-mt-2">
                    <label v-if="field.label" :for="'custom_field_' + index" class="form-group-label c-charcoal">{{ field.label }}</label>
                    <input
                        type="text"
                        :name="'custom_field_' + index"
                        :id="'custom_field_' + index"
                        class="input-text full-width"
                        :placeholder="field.placeholder"
                        v-model="form.custom_fields.fields[index].value">
                </div>
            </div>

            <div class="card card--large card--green mb-3">
                <h3 class="mb-3 sm-mb-2 text-center">Your details</h3>

                <div class="d-flex flex-wrap mx--8px sm-mx--0">
                    <div class="f1 sm-f-100 mx-1 mb-3 sm-mb-2 sm-mx-0">
                        <label for="first_name" class="form-group-label c-charcoal required">First Name</label>
                        <input
                            type="text"
                            name="first_name"
                            id="first_name"
                            class="input-text full-width"
                            :class="{'error' : $v.form.first_name.$error}"
                            v-model="form.first_name">
                        <!-- Validation Error -->
                        <div v-if="$v.form.first_name.$error"
                             class="m-top-1">
                            <div class="txt-error">
                                <!-- FRONT END VALIDATION ERROR MESSAGES -->
                                <template v-if="$v.form.first_name.$error">
                                    <template v-for="param in $v.form.first_name.$params">
                                        <div v-if="!$v.form.first_name[param.type]">
                                            {{ messages.get('first_name',param.type) }}
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <!-- END Validation Error -->
                    </div>
                    <div class="f1 sm-f-100 mx-1 mb-3 sm-mb-2 sm-mx-0">
                        <label for="last_name" class="form-group-label c-charcoal required">Last Name</label>
                        <input
                            type="text"
                            name="last_name"
                            id="last_name"
                            class="input-text full-width"
                            :class="{'error' : $v.form.last_name.$error}"
                            v-model="form.last_name">
                        <!-- Validation Error -->
                        <div v-if="$v.form.last_name.$error"
                             class="m-top-1">
                            <div class="txt-error">
                                <!-- FRONT END VALIDATION ERROR MESSAGES -->
                                <template v-if="$v.form.last_name.$error">
                                    <template v-for="param in $v.form.last_name.$params">
                                        <div v-if="!$v.form.last_name[param.type]">
                                            {{ messages.get('last_name',param.type) }}
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <!-- END Validation Error -->
                    </div>
                </div>

                <div class="d-flex flex-wrap mx--8px sm-mx--0">
                    <div class="f1 sm-f-100 mx-1 mb-3 sm-mb-2 sm-mx-0">
                        <label for="email" class="form-group-label c-charcoal required">Email Address</label>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            class="input-text full-width"
                            :class="{'error' : $v.form.email.$error}"
                            v-model="form.email">
                        <!-- Validation Error -->
                        <div v-if="$v.form.email.$error"
                             class="m-top-1">
                            <div class="txt-error">
                                <!-- FRONT END VALIDATION ERROR MESSAGES -->
                                <template v-if="$v.form.email.$error">
                                    <template v-for="param in $v.form.email.$params">
                                        <div v-if="!$v.form.email[param.type]">
                                            {{ messages.get('email',param.type) }}
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <!-- END Validation Error -->
                    </div>
                    <div class="f1 sm-f-100 mx-1 mb-3 sm-mb-2 sm-mx-0">
                        <label for="phone" class="form-group-label c-charcoal">Mobile Number</label>
                        <input
                            type="tel"
                            name="phone"
                            id="phone"
                            class="input-text full-width"
                            :class="{'error' : $v.form.phone.$error}"
                            v-model="form.phone">
                        <!-- Validation Error -->
                        <div v-if="$v.form.phone.$error"
                             class="m-top-1">
                            <div class="txt-error">
                                <!-- FRONT END VALIDATION ERROR MESSAGES -->
                                <template v-if="$v.form.phone.$error">
                                    <template v-for="param in $v.form.phone.$params">
                                        <div v-if="!$v.form.phone[param.type]">
                                            {{ messages.get('phone',param.type) }}
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <!-- END Validation Error -->
                    </div>
                </div>

                <div class="fs-14 lh-13 fw-light">
                    Your support is helping us to change lives. We look forward to keeping in touch with you by post and phone with information about our work and how you can get involved with us, for example through fundraising or volunteering.
                </div>
                <div class="mt-3 sm-mt-2 d-flex">
                    <label
                        class="checkbox"
                        :class="{'disabled' : marketing_by_email.disabled}">
                        <input type="checkbox"
                               class="input-checkbox"
                               :disabled="marketing_by_email.disabled"
                               v-model="form.marketing_by_email">
                        <span class="checkmark"></span>
                    </label>
                    <div class="fs-14 fw-light my-auto mr-2">{{ marketing_by_email.label }}</div>
                </div>

                <div class="mt-3 sm-mt-2 d-flex">
                    <label
                        class="checkbox"
                        :class="{'disabled' : marketing_by_post.disabled}">
                        <input type="checkbox"
                               class="input-checkbox"
                               :disabled="marketing_by_post.disabled"
                               v-model="form.marketing_by_post">
                        <span class="checkmark"></span>
                    </label>
                    <div class="fs-14 fw-light my-auto mr-2">{{ marketing_by_post.label }}</div>
                </div>

                <div class="fs-14 lh-13 fw-light mt-4">
                    We promise to keep your details safe and never share them. Our <a href="/privacy-policy">privacy policy</a> explains how we keep this promise. If you don't want to hear from us, or you change your mind about how we contact you, please email <a href="mailto:marketing@minsteadtrust.org.uk">marketing@minsteadtrust.org.uk</a> or call <a href="tel:02380812297">02380 812297</a>
                </div>
            </div>

            <div class="card card--large card--green mb-3">
                <h3 class="mb-3 sm-mb-2 text-center">Your address</h3>

                <div class="mb-3 sm-mb-2">
                    <label for="address_line_one" class="form-group-label c-charcoal required">Address Line 1</label>
                    <input
                        type="text"
                        name="address_line_one"
                        id="address_line_one"
                        class="input-text full-width"
                        :class="{'error' : $v.form.address_line_one.$error}"
                        v-model="form.address_line_one">
                    <!-- Validation Error -->
                    <div v-if="$v.form.address_line_one.$error"
                         class="m-top-1">
                        <div class="txt-error">
                            <!-- FRONT END VALIDATION ERROR MESSAGES -->
                            <template v-if="$v.form.address_line_one.$error">
                                <template v-for="param in $v.form.address_line_one.$params">
                                    <div v-if="!$v.form.address_line_one[param.type]">
                                        {{ messages.get('address_line_one',param.type) }}
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                    <!-- END Validation Error -->
                </div>

                <div class="mb-3 sm-mb-2">
                    <label for="address_line_two" class="form-group-label c-charcoal">Address Line 2 (optional)</label>
                    <input
                        type="text"
                        name="address_line_two"
                        id="address_line_two"
                        class="input-text full-width"
                        :class="{'error' : $v.form.address_line_two.$error}"
                        v-model="form.address_line_two">
                    <!-- Validation Error -->
                    <div v-if="$v.form.address_line_two.$error"
                         class="m-top-1">
                        <div class="txt-error">
                            <!-- FRONT END VALIDATION ERROR MESSAGES -->
                            <template v-if="$v.form.address_line_two.$error">
                                <template v-for="param in $v.form.address_line_two.$params">
                                    <div v-if="!$v.form.address_line_two[param.type]">
                                        {{ messages.get('address_line_two',param.type) }}
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                    <!-- END Validation Error -->
                </div>

                <div class="d-flex flex-wrap mx--8px sm-mx--0">
                    <div class="f1 sm-f-100 mx-1 mb-3 sm-mb-2 sm-mx-0">
                        <label for="town_or_city" class="form-group-label c-charcoal required">Town or City</label>
                        <input
                            type="text"
                            name="town_or_city"
                            id="town_or_city"
                            class="input-text full-width"
                            :class="{'error' : $v.form.town_or_city.$error}"
                            v-model="form.town_or_city">
                        <!-- Validation Error -->
                        <div v-if="$v.form.town_or_city.$error"
                             class="m-top-1">
                            <div class="txt-error">
                                <!-- FRONT END VALIDATION ERROR MESSAGES -->
                                <template v-if="$v.form.town_or_city.$error">
                                    <template v-for="param in $v.form.town_or_city.$params">
                                        <div v-if="!$v.form.town_or_city[param.type]">
                                            {{ messages.get('town_or_city',param.type) }}
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <!-- END Validation Error -->
                    </div>
                    <div class="f1 sm-f-100 mx-1 mb-3 sm-mb-2 sm-mx-0">
                        <label for="post_code" class="form-group-label c-charcoal required">Postcode</label>
                        <input
                            type="text"
                            name="post_code"
                            id="post_code"
                            class="input-text full-width"
                            :class="{'error' : $v.form.post_code.$error}"
                            v-model="form.post_code">
                        <!-- Validation Error -->
                        <div v-if="$v.form.post_code.$error"
                             class="m-top-1">
                            <div class="txt-error">
                                <!-- FRONT END VALIDATION ERROR MESSAGES -->
                                <template v-if="$v.form.post_code.$error">
                                    <template v-for="param in $v.form.post_code.$params">
                                        <div v-if="!$v.form.post_code[param.type]">
                                            {{ messages.get('post_code',param.type) }}
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <!-- END Validation Error -->
                    </div>
                </div>

                <div class="mb-3 sm-mb-2 mx--8px sm-mx--0 half-width sm-full-width">
                    <div class="mx-1 sm-mx-0">
                        <label for="country" class="form-group-label c-charcoal required">Country</label>
                        <select
                            name="country"
                            id="country"
                            class="input-select full-width"
                            :class="{'error' : $v.form.country.$error}"
                            v-model="form.country">
                            <option
                                v-for="country in countries"
                                :key="country.code"
                                :value="country.code">{{ country.name }}</option>
                        </select>
                        <!-- Validation Error -->
                        <div v-if="$v.form.country.$error"
                             class="m-top-1">
                            <div class="txt-error">
                                <!-- FRONT END VALIDATION ERROR MESSAGES -->
                                <template v-if="$v.form.country.$error">
                                    <template v-for="param in $v.form.country.$params">
                                        <div v-if="!$v.form.country[param.type]">
                                            {{ messages.get('country',param.type) }}
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <!-- END Validation Error -->
                    </div>
                </div>

            </div>

            <div class="d-flex justify-content-center">
                <button type="submit" class="btn --default" @click.prevent="submit">Next: Payment</button>
            </div>

        </form>

    </div>

</template>

<script>

    import {mapGetters,mapActions} from 'vuex';
    import { required, minLength, email } from 'vuelidate/lib/validators';

    import ValidationReporting from '@/helpers/ValidationReporting';
    import { Countries } from '@/configuration/Countries';

    export default {
        name: 'DonationDetails',

        props: {
            amount: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                form: {
                    first_name: '',
                    last_name: '',
                    name: '',
                    email: '',
                    phone: '',
                    address_line_one: '',
                    address_line_two: '',
                    town_or_city: '',
                    post_code: '',
                    country: 'GB',
                    custom_fields: {
                        title: '',
                        fields: []
                    },
                    marketing_by_post: false,
                    marketing_by_email: false,
                },
                marketing_by_email: {
                    disabled: false,
                    label: 'Hear from us by email'
                },

                marketing_by_post: {
                    disabled: false,
                    label: 'Hear from us by SMS'
                },

                countries: Countries,
                messages: new ValidationReporting(),
            }
        },

        validations: {
            form: {
                first_name: {required, minLength: minLength(2)},
                last_name: {required, minLength: minLength(2)},
                email: {required, email},
                phone: {},
                address_line_one: {required},
                address_line_two: {},
                town_or_city: {required},
                post_code: {required},
                country: {required}
            }
        },

        computed: {
            ...mapGetters('Donations', {
                cacheForm: 'donationDetails',
                block: 'donationOptions',
                loadingOptions: 'fetchingOptions'
            }),
            fullname() {
                return this.form.first_name + ' ' + this.form.last_name;
            }
        },

        watch: {
            form: {
                deep: true,
                handler(val) {
                    this.preserveDetails(val);
                }
            },
            fullname(val) {
                this.form.name = val;
            }
        },

        created() {
            if (this.cacheForm) {
                this.form = this.cacheForm;
            }

            this.mapCustomFields();

        },

        methods: {
            ...mapActions('Donations', ['preserveDetails']),
            mapCustomFields() {
                if (this.block.custom_fields) {
                    this.form.custom_fields.title = this.block.custom_fields.title;
                    this.form.custom_fields.fields = this.block.custom_fields.fields;
                }
            },
            submit() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    this.$root.scrollToError();
                    return;
                }

                this.$emit('completed');
            },
        }
    }

</script>
